import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ClickedOutsideModule } from 'src/app/directives/clicked-outside.directive';
import { EventTrackerModule } from 'src/app/directives/event-tracker.directive';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MultimediaPlayerComponent } from './multimedia-player/multimedia-player.component';
import { DropdownContentComponent } from './dropdown-content/dropdown-content.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ChipComponent } from './chip/chip.component';
import { BaseModalComponent } from './base-modal/base-modal.component';
import { OptionalInputAutocompleteComponent } from './autocomplete/optional-input-autocomplete/optional-input-autocomplete.component';
@NgModule({
  declarations: [
    MultimediaPlayerComponent,
    DropdownContentComponent,
    AutocompleteComponent,
    ChipComponent,
    BaseModalComponent,
    OptionalInputAutocompleteComponent,
  ],
  exports: [
    MultimediaPlayerComponent,
    DropdownContentComponent,
    AutocompleteComponent,
    ChipComponent,
    BaseModalComponent,
    OptionalInputAutocompleteComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ClickedOutsideModule,
    EventTrackerModule,
    PipesModule,
    MatAutocompleteModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GlobalComponentsModule { }
